import React, { Fragment } from "react";

import {
  IonText,
  IonCard,
  IonCardContent,
  IonItem,
  IonLabel,
  IonList,
} from "@ionic/react";

import { useParams } from "react-router-dom";

import Page from "../../components/Page/Page";
import { IonListLoading } from "../../components/Ui/IonListLoading";

import { HelpType } from "../../interfaces/help";

import { useTicket } from "../../hooks/useTicket";

import Organization from "../../components/Ui/Organization";

import { useHelps } from "../../hooks/useHelps";

import "./style.css";

const TicketItem: React.FC<{ id?: string }> = ({ id }) => {
  let { ticket } = useTicket({ id });
  return (
    <Organization loading={false} organization={ticket.car.organization} />
  );
};

const HelpPage: React.FC = () => {
  const { loading, data } = useHelps();

  const { id } = useParams();

  return (
    <Page name="Ajuda" back={id ? `/page/passage/${id}` : "/page/passage"}>
      <div className="help-page">
        <IonText>
          <h4 style={{ marginLeft: "10px", fontSize: "17px" }}>
            Ajuda sobre esta passagem
          </h4>
        </IonText>
            {loading ? <IonListLoading labelWidth="100%" /> : null}
            {!loading ? (
              <Fragment>
                {id ? <TicketItem id={id} /> : null}
                <IonCard>
                  <IonCardContent className="no-padding">
                    <IonList style={{ paddingTop: 0 }}>
                      {data.getHelpTypes.map((helpType: HelpType, i: number) => {
                        return (
                          <IonItem
                            button
                            key={`help-type-${helpType.id}`}
                            lines="full"
                            routerLink={`/page/new-help/${id}/${helpType.id}`}
                          >
                            <IonLabel>
                              <h3>{helpType.title}</h3>
                              <p>{helpType.excerpt}</p>
                            </IonLabel>
                          </IonItem>
                        );
                      })}
                    </IonList>
                  </IonCardContent>
                </IonCard>
              </Fragment>
            ) : null}
      </div>
    </Page>
  );
};

export default HelpPage;
